export const CONTRACT_TYPES = {
    BASIC: 7,
    INDIVIDUAL: 8,
    FAMILIAR: 84,
    BASIC_PLUS: 83,
    INDIVIDUAL_PLUS: 86,
    FAMILIAR_PLUS: 88,
    PET_PLAN: 92,
};

export const KINSHIP_CODES = {
    PET: 'MA',
};

// Catalog type for banks (EnumCatalogsTypes.Banks = 1018)
export const BANK_CATALOG_TYPE = 1018;

// Transfer type IDs that do NOT go through a bank (no bank selection needed)
export const NON_BANK_TRANSFER_TYPES = [18, 75]; // 18 = Efectivo, 75 = Ahorros

// Bank configuration bitmask per transfer type (matches par_catalogs.configuration on Banks catalog)
//   bit 0 (1) = Tarjeta (19)
//   bit 1 (2) = Depósito (59)
//   bit 2 (4) = Cheque (42)
export const BANK_CONFIG_BY_TRANSFER_TYPE = {
    19: 1, // Tarjeta
    59: 2, // Depósito
    42: 4, // Cheque
};
